
import { Component, Vue, Prop } from 'vue-property-decorator'
import { GroupEntity, GroupStatus } from '@/types/catalogs/Groups'
import DateFormat from '@/services/DateFormat'

@Component({
  name: 'GroupListItem'
})
export default class GroupListItem extends Vue {
  @Prop({ required: true })
  group: GroupEntity

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false
  groupStatus = GroupStatus

  get creationDate () {
    return this.group.creationDate
      ? new DateFormat(this.group.creationDate).toDateString()
      : '- - / - - / - - - -'
  }

  get updateDate () {
    return this.group.updateDate
      ? new DateFormat(this.group.updateDate).toDateString()
      : '- - / - - / - - - -'
  }

  get title () {
    return this.open ? 'Ocultar subgrupos' : 'Ver subgrupos'
  }

  get isSelected () {
    return this.selectedId === this.group.id
  }

  get titleSelect () {
    return this.isSelected ? 'Clic para deseleccionar' : 'Clic para seleccionar'
  }

  get subGroupsList () {
    return this.group.subGroups && this.group.subGroups.length ? this.group.subGroups.map(g => g.name).join(', ') : ''
  }

  get usersList () {
    return this.group.users && this.group.users.length ? this.group.users.map(g => g.name).join(', ') : ''
  }

  get projectsList () {
    return this.group.projects && this.group.projects.length ? this.group.projects.map(g => g.name).join(', ') : ''
  }

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
